import { createClient } from "@connectrpc/connect";
import { ISaveService } from "../../../../abstractions/services/actions/ISaveService";
import { grpcTransportProvider } from "../../../../comun/services/grpc/GrpcTransport";
import { mapConnectError } from "../../../../comun/services/grpc/mapConnectError";
import { TareaService } from "../../../../generated/grpc/configuracion_tarea_pb";
import { grpcTareaDatabase } from "../database/GrpcTareaDatabase";
import { TareaRequest } from "../request/TareaRequest";
import { TareaResponse } from "../response/TareaResponse";
import { fx_createTareaGrpcService, toTareaResponse } from "./TareaGrpcService";

/** Variante gRPC-Web de `TareaSaveService` (ver ese archivo): mismo guardado
 *  crear-o-actualizar (`id` ausente = crear). */
export class TareaSaveGrpcService
  implements ISaveService<TareaRequest, TareaResponse>
{
  async saveAsync(request: TareaRequest): Promise<TareaResponse> {
    const client = createClient(TareaService, grpcTransportProvider.get());

    let saved;
    try {
      saved = await client.guardar({
        id: request.id ?? undefined,
        clienteId: request.clienteId,
        nombre: request.nombre,
      });
    } catch (error) {
      throw mapConnectError(error);
    }

    await grpcTareaDatabase.putOneAsync(saved);
    if (saved.clienteId) fx_createTareaGrpcService(saved.clienteId).clearCache();
    return toTareaResponse(saved);
  }
}
